import {
  TERMINACION_REQUEST,
  TERMINACION_SUCCESS,
  TERMINACION_FAILURE,
  TERMINACION_DOCS_SUCCESS,
  TERMINACION_SAVE_SUCCESS,
  TERMINACION_FORMAS_SUCCESS,
  TERMINACION_PARCIALIDADES_SUCCESS,
} from "../actions/terminacion/types";

const initialState = {
  item: null,
  documentos: [],
  formas: [],
  parcialidadesList: [],
  loading: false,
  error: null,
};

const terminacionReducer = (state = initialState, action) => {
  switch (action.type) {
    case TERMINACION_REQUEST:
      return { ...state, loading: true, error: null };
    case TERMINACION_SUCCESS:
      return { ...state, loading: false, item: action.payload?.item ?? null };
    case TERMINACION_SAVE_SUCCESS:
      return { ...state, loading: false };
    case TERMINACION_DOCS_SUCCESS:
      return { ...state, documentos: action.payload?.items ?? [] };
    case TERMINACION_FORMAS_SUCCESS:
      return { ...state, formas: Array.isArray(action.payload) ? action.payload : action.payload?.items ?? [] };
    case TERMINACION_PARCIALIDADES_SUCCESS:
      return { ...state, parcialidadesList: Array.isArray(action.payload) ? action.payload : action.payload?.items ?? [] };
    case TERMINACION_FAILURE:
      return { ...state, loading: false, error: action.payload?.error };
    default:
      return state;
  }
};

export default terminacionReducer;
